export default "__VITE_ASSET__edd0cca6__"